














































































import Joi from 'joi';
import { Component, Prop, Vue } from 'vue-property-decorator';
import contactMethodData from '../../data/contact-method.json';
import languageText from '../../language/en.json';
import { sendCooperationForm } from '../../utils/email';
import { CooperationFormModel } from './model/cooperation-form.model';

@Component
export default class CooperatorForm extends Vue {
  @Prop() private msg!: string;

  @Prop() private companyName!: string;

  username = ''

  jobPosition = ''

  company = ''

  emailContact = ''

  contactMethod = []

  emailJSServiceId = process.env.VUE_APP_EMAILJS_SERVICE_ID

  emailTemplateId = process.env.MATCHING_TEMPLATE_ID

  emailUserId = process.env.VUE_APP_USER_ID

  contactMethodItem = contactMethodData.contactMethodItem

  errors: any = {}

  issues: any = {}

  private async submitForm() {
    const contactMethodText = this.contactMethod
      .map((method) => languageText[method] || method);

    await sendCooperationForm(
      this.emailJSServiceId,
      this.emailTemplateId,
      this.emailUserId,
      {
        counterParty: this.username,
        jobPosition: this.jobPosition,
        companyName: this.company,
        email: this.emailContact,
        contactMethod: contactMethodText,
      },
    );

    this.$toast('Email Sent !');
  }

  private async register() {
    this.errors = {};
    this.issues = {};

    const cooperationFormValidation = Joi.object().keys({
      emailContact: Joi.string().email({ tlds: { allow: false } }).required(),
      username: Joi.string().required(),
      jobPosition: Joi.string().required(),
      company: Joi.string().required(),
      contactMethod: Joi.array().items(Joi.string().required()).required(),
    });

    const validationResult = cooperationFormValidation.validate({
      emailContact: this.emailContact,
      username: this.username,
      jobPosition: this.jobPosition,
      company: this.company,
      contactMethod: this.contactMethod,
    });

    if (validationResult.error) {
      validationResult.error.details.forEach((error) => {
        this.issues[error.path[0]] = error.message;
      });
      this.errors = this.issues;
      return false;
    }

    this.submitForm();
    this.clear();
    return true;
  }

  private clear() {
    this.username = '';
    this.emailContact = '';
    this.company = '';
    this.jobPosition = '';
    this.contactMethod = [];
  }
}
